import React, { Component } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Header from './Header'
import { SEOHeaders } from "./SeoHeaders"
import { config } from './config'
import LandingImage from './LandingImage'
import ReactFlow, { Background, Node, Edge } from 'reactflow'
import UsersSource from './nodes/UsersSource'
import UsersPool from './nodes/UsersPool'
import UsersProcessor from './nodes/UsersProcessor'
import UsersMoneyTransform from './nodes/UsersMoneyTransform'
import MoneyPool from './nodes/MoneyPool'
import MoneySource from './nodes/MoneySource'
import MoneyProcessor from './nodes/MoneyProcessor'

const nodeTypes: any = {
    'UsersSource': UsersSource,
    'UsersPool': UsersPool,
    'UsersProcessor': UsersProcessor,
    'UsersMoneyTransform': UsersMoneyTransform,
    'MoneyPool': MoneyPool,
    'MoneySource': MoneySource,
    'MoneyProcessor': MoneyProcessor
}

const defaultEdgeOptions = { animated: true }

interface LandingProps {
    navigate: any
}

type LandingStates = {
    subSuccess: boolean
    subEmail: string
    plans: any[]
    showedges: any[]
    shownodes: any[]
}

class Landing extends Component <LandingProps, LandingStates> {
  constructor (props: LandingProps) {
    super(props)
    this.state = {
        subSuccess: false,
        subEmail: '',
        plans: [],
        showedges: [],
        shownodes: []
    }
  }

  componentDidMount () {
    this.loadPublicPlans()
  }

  inputChange = (event: any) => {
    this.setState({ [event.currentTarget.name]: event.currentTarget.value } as LandingStates)
  }

  loadPublicPlans = () => {
    fetch(
      config.app.apiUri + '/api/v1/plans?public=true&limit=3', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((response) => { return response.json() })
      .then((json) => {
        if (json.status === 'success') {
            // console.log(json.plans)
            this.setState({
                plans: json.plans,
                showedges: json.plans[0].data.edges,
                shownodes: json.plans[0].data.nodes
            })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  handleImgError = (e: any) => {
    e.target.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAADICAYAAADGFbfiAAAHFklEQVR4Xu3VsQ0AAAjDMPr/0/yQ2exdLKTsHAECBAgQCAILGxMCBAgQIHAC4gkIECBAIAkISGIzIkCAAAEB8QMECBAgkAQEJLEZESBAgICA+AECBAgQSAICktiMCBAgQEBA/AABAgQIJAEBSWxGBAgQICAgfoAAAQIEkoCAJDYjAgQIEBAQP0CAAAECSUBAEpsRAQIECAiIHyBAgACBJCAgic2IAAECBATEDxAgQIBAEhCQxGZEgAABAgLiBwgQIEAgCQhIYjMiQIAAAQHxAwQIECCQBAQksRkRIECAgID4AQIECBBIAgKS2IwIECBAQED8AAECBAgkAQFJbEYECBAgICB+gAABAgSSgIAkNiMCBAgQEBA/QIAAAQJJQEASmxEBAgQICIgfIECAAIEkICCJzYgAAQIEBMQPECBAgEASEJDEZkSAAAECAuIHCBAgQCAJCEhiMyJAgAABAfEDBAgQIJAEBCSxGREgQICAgPgBAgQIEEgCApLYjAgQIEBAQPwAAQIECCQBAUlsRgQIECAgIH6AAAECBJKAgCQ2IwIECBAQED9AgAABAklAQBKbEQECBAgIiB8gQIAAgSQgIInNiAABAgQExA8QIECAQBIQkMRmRIAAAQIC4gcIECBAIAkISGIzIkCAAAEB8QMECBAgkAQEJLEZESBAgICA+AECBAgQSAICktiMCBAgQEBA/AABAgQIJAEBSWxGBAgQICAgfoAAAQIEkoCAJDYjAgQIEBAQP0CAAAECSUBAEpsRAQIECAiIHyBAgACBJCAgic2IAAECBATEDxAgQIBAEhCQxGZEgAABAgLiBwgQIEAgCQhIYjMiQIAAAQHxAwQIECCQBAQksRkRIECAgID4AQIECBBIAgKS2IwIECBAQED8AAECBAgkAQFJbEYECBAgICB+gAABAgSSgIAkNiMCBAgQEBA/QIAAAQJJQEASmxEBAgQICIgfIECAAIEkICCJzYgAAQIEBMQPECBAgEASEJDEZkSAAAECAuIHCBAgQCAJCEhiMyJAgAABAfEDBAgQIJAEBCSxGREgQICAgPgBAgQIEEgCApLYjAgQIEBAQPwAAQIECCQBAUlsRgQIECAgIH6AAAECBJKAgCQ2IwIECBAQED9AgAABAklAQBKbEQECBAgIiB8gQIAAgSQgIInNiAABAgQExA8QIECAQBIQkMRmRIAAAQIC4gcIECBAIAkISGIzIkCAAAEB8QMECBAgkAQEJLEZESBAgICA+AECBAgQSAICktiMCBAgQEBA/AABAgQIJAEBSWxGBAgQICAgfoAAAQIEkoCAJDYjAgQIEBAQP0CAAAECSUBAEpsRAQIECAiIHyBAgACBJCAgic2IAAECBATEDxAgQIBAEhCQxGZEgAABAgLiBwgQIEAgCQhIYjMiQIAAAQHxAwQIECCQBAQksRkRIECAgID4AQIECBBIAgKS2IwIECBAQED8AAECBAgkAQFJbEYECBAgICB+gAABAgSSgIAkNiMCBAgQEBA/QIAAAQJJQEASmxEBAgQICIgfIECAAIEkICCJzYgAAQIEBMQPECBAgEASEJDEZkSAAAECAuIHCBAgQCAJCEhiMyJAgAABAfEDBAgQIJAEBCSxGREgQICAgPgBAgQIEEgCApLYjAgQIEBAQPwAAQIECCQBAUlsRgQIECAgIH6AAAECBJKAgCQ2IwIECBAQED9AgAABAklAQBKbEQECBAgIiB8gQIAAgSQgIInNiAABAgQExA8QIECAQBIQkMRmRIAAAQIC4gcIECBAIAkISGIzIkCAAAEB8QMECBAgkAQEJLEZESBAgICA+AECBAgQSAICktiMCBAgQEBA/AABAgQIJAEBSWxGBAgQICAgfoAAAQIEkoCAJDYjAgQIEBAQP0CAAAECSUBAEpsRAQIECAiIHyBAgACBJCAgic2IAAECBATEDxAgQIBAEhCQxGZEgAABAgLiBwgQIEAgCQhIYjMiQIAAAQHxAwQIECCQBAQksRkRIECAgID4AQIECBBIAgKS2IwIECBAQED8AAECBAgkAQFJbEYECBAgICB+gAABAgSSgIAkNiMCBAgQEBA/QIAAAQJJQEASmxEBAgQICIgfIECAAIEkICCJzYgAAQIEBMQPECBAgEASEJDEZkSAAAECAuIHCBAgQCAJCEhiMyJAgAABAfEDBAgQIJAEBCSxGREgQICAgPgBAgQIEEgCApLYjAgQIEBAQPwAAQIECCQBAUlsRgQIECAgIH6AAAECBJKAgCQ2IwIECBAQED9AgAABAklAQBKbEQECBAgIiB8gQIAAgSQgIInNiAABAgQExA8QIECAQBIQkMRmRIAAAQIC4gcIECBAIAkISGIzIkCAAAEB8QMECBAgkAQEJLEZESBAgICA+AECBAgQSAICktiMCBAgQOABB1wAyWjdfzMAAAAASUVORK5CYII=";
  }

  subscribe = (event: any) => {
    event.preventDefault()
    fetch(
      config.app.apiUri + '/api/v1/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: this.state.subEmail
        })
      })
      .then((response) => { return response.json() })
      .then((json) => {
        if (json.status === 'success') {
            this.setState({subSuccess: true})
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  render() {
    return (
      <div id="home" className='overflow-hidden'>
        <SEOHeaders/>
        <Header/>
        <div className="fw-light text-secondary">
            <section className="pb-5 pt-5 text-dark">
                <div className="container">
                    <div className="align-items-center row">
                        <div className="col-lg-5 col-xl-5 mx-auto">
                            <h1 className="display-8 fw-normal mb-5 text-dark">Seamless Growth & Financial Modeling</h1>
                            <p className="fw-light mb-5">We believe in empowering entrepreneurs and business leaders to visualize their company's potential without getting lost in the details. In a world overflowing with data, clarity and simplicity are paramount.</p><a href="/signup" className="btn btn-primary fw-light pb-2 ps-3 pe-3 pt-2">Get Started</a><a href="/community" className="btn btn-secondary fw-light pb-2 ps-3 pe-3 pt-2 ms-3">Explore</a>
                        </div>
                        <div className="col-lg-7 pb-3 pt-3 d-none d-lg-block d-xl-block d-xxl-block">
                            <div style={{width: 1200, paddingLeft: 50, height: '75vh'}}>
                                <ReactFlow
                                    nodes={this.state.shownodes}
                                    edges={this.state.showedges}
                                    nodeTypes={nodeTypes}
                                    defaultEdgeOptions={defaultEdgeOptions}
                                    nodeOrigin={[0.5, 0.5]}
                                    fitView={true}
                                    maxZoom={1}
                                    minZoom={0.1}
                                    panOnDrag={false}
                                    zoomOnScroll={false}
                                    zoomOnPinch={false}
                                    zoomOnDoubleClick={false}
                                    preventScrolling={false}
                                    panOnScroll={false}
                                >
                                </ReactFlow>
                            </div>
                        </div>
                        <div className="d-lg-none d-xl-none d-xxl-none">
                            <div style={{width: '100%', height: 400}}>
                                <ReactFlow
                                    nodes={this.state.shownodes}
                                    edges={this.state.showedges}
                                    nodeTypes={nodeTypes}
                                    defaultEdgeOptions={defaultEdgeOptions}
                                    nodeOrigin={[0.5, 0.5]}
                                    fitView={true}
                                    maxZoom={1}
                                    minZoom={0.1}
                                    panOnDrag={false}
                                    zoomOnScroll={false}
                                    zoomOnPinch={false}
                                    zoomOnDoubleClick={false}
                                    preventScrolling={false}
                                    panOnScroll={false}
                                >
                                </ReactFlow>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="bg-primary pb-5 pt-5 text-white" id="community"> 
                <div className="container pb-3 pt-3"> 
                    <div className="align-items-center row"> 
                        <div className="col-lg-5 mt-n5 order-lg-2 pb-3 pt-3 d-none d-lg-block d-xl-block d-xxl-block" style={{paddingLeft: 100}}> 
                            <LandingImage/>
                        </div>
                        <div className="col-lg-5 mt-n5 order-lg-2 pb-3 pt-3 d-lg-none d-xl-none d-xxl-none ps-5 pe-5">
                            <div className="mx-auto" style={{width: "50%"}}>
                                <LandingImage/>
                            </div>
                        </div>
                        <div className="col-lg-7 ms-auto order-lg-1 pb-3 pt-3"> 
                            <h2 className="fw-normal h1 mb-4">Explore Community</h2>
                            <p className="fw-light mb-4">Rather than starting from scratch, find a community model that closely resonates with your company's values and replicate it. Integrate your company's unique attributes, and you're good to go!</p>
                            <a href="/community" className="btn btn-dark fw-light pb-2 mb-4 ps-3 pe-3 pt-2">Explore</a>
                            <div className="row pt-4">
                                {this.state.plans.map((plan:any) => {
                                    return <div key={plan.id} className="col-xxl-4 col-lg-4 col-md-4 col-xs-12 pb-3">
                                        <div className="card" style={{cursor: 'pointer'}}>
                                            <img src={plan.image} onClick={()=>this.props.navigate('/p/'+plan.id)} className="card-img-top" alt="..." onError={this.handleImgError}/>
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between">
                                                <h5 onClick={()=>this.props.navigate('/p/'+plan.id)} className="card-title fw-normal text-truncate">{plan.name}</h5>
                                                </div>
                                                <p onClick={()=>this.props.navigate('/p/'+plan.id)} className="card-text text-truncate fw-normal link-secondary">{plan.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>                     
                    </div>                 
                </div>             
            </section>
            <svg viewBox="0 0 100 100" preserveAspectRatio="none" fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" height="64" width="100%" className="bg-primary d-block text-light">
                <path d="M 100 100 V 0 L 0 100"/>
            </svg>
            <section className="bg-light pb-5 pt-5 text-center" id="pricing"> 
                <div className="container pb-4 pt-4">
                    <div className="align-items-center row">
                        <div className="col-6">
                            <h2 className="fw-normal h1 mb-5 text-dark">One plan for lifetime</h2>
                            <p className='mb-4'>We believe in transparency and value. That's why our pricing is designed to give you peace of mind and the best possible experience.</p>
                            <p><span className="fw-bold text-dark">Long-term Savings:</span> Say goodbye to monthly payments.</p>
                            <p><span className="fw-bold text-dark">Predictable Budgeting:</span> Without recurring fees.</p>
                            <p><span className="fw-bold text-dark">Price Stability:</span> No worries about sudden price hikes or changes.</p>
                        </div>
                        <div className="col-6">
                            <div className="align-items-center justify-content-center row"> 
                                <div className="col-md-6 py-3"> 
                                    <div className="bg-light border rounded text-secondary"> 
                                        <div className="align-items-center d-flex fw-light h5 justify-content-center pb-4 pe-3 ps-3 pt-4"> <span className="align-self-start">$</span> <span className="display-4 fw-normal text-dark">74</span> <span className="align-self-end">/lifetime</span></div>                                 
                                        <h3 className="bg-dark fw-normal h4 mb-0 pb-3 pe-2 ps-2 pt-3 text-uppercase text-white">Lifetime</h3> 
                                        <div className="pb-5 ps-3 pe-3 pt-4">
                                            <ul className="list-unstyled mb-4">
                                                <li className="pb-2 pt-2">Unlimited models</li>
                                                <li className="pb-2 pt-2">Graphs on every step</li>
                                                <li className="pb-2 pt-2">Community access</li>
                                                <li className="pb-2 pt-2">Sharing links</li>
                                                <li className="pb-2 pt-2">Support</li>
                                            </ul>
                                            <a href="/signup" className="btn btn-dark fw-light pb-2 ps-4 pe-4 pt-2">Sign Up</a> 
                                        </div>
                                    </div>
                                </div>
                            </div>                     
                        </div>
                    </div>
                </div>             
            </section>
            <footer className="bg-dark pt-5 text-white"> 
                <div className="container"> 
                    <div className="row"> 
                        <div className="col-xl-4 py-3"> <a href="/#home" className="d-inline-block fw-bold h4 link-light mb-4 text-decoration-none" target="_pg_blank">MODELR.XYZ</a> 
                            <p className="mb-3">We believe in empowering entrepreneurs and business leaders to visualize their company's potential without getting lost in the details.</p> 
                            <div className="mb-4"><a href="mailto:contact@modelr.xyz" className="link-light text-decoration-none">contact@modelr.xyz</a> 
                            </div>                         
                        </div>                     
                        <div className="col-md-3 col-xl-2 py-3"> 
                            <h2 className="fw-normal h5 mb-4 text-uppercase text-white">About</h2> 
                            <ul className="list-unstyled"> 
                                <li className="mb-3"> <a href="/#home" className="link-light text-decoration-none">Home</a> 
                                </li>                             
                                <li className="mb-3"> <a href="/#features" className="link-light text-decoration-none">Features</a> 
                                </li>                             
                                <li className="mb-3"> <a href="/#community" className="link-light text-decoration-none">Community</a> 
                                </li>                             
                                <li className="mb-3"> <a href="/#pricing" className="link-light text-decoration-none">Pricing</a> 
                                </li>                             
                            </ul>                         
                        </div>                     
                        <div className="col-md-3 col-xl-2 py-3"> 
                            <h2 className="fw-normal h5 mb-4 text-uppercase text-white">Models</h2> 
                            <ul className="list-unstyled"> 
                                <li className="mb-3"> <a href="/community?query=sass" className="link-light text-decoration-none">SaSS models</a> 
                                </li>                             
                                <li className="mb-3"> <a href="/community?query=startup" className="link-light text-decoration-none">Startup models</a> 
                                </li>                             
                                <li className="mb-3"> <a href="/community?query=dropshipping" className="link-light text-decoration-none">Dropshipping</a> 
                                </li>                             
                                <li className="mb-3"> <a href="/community?query=growth" className="link-light text-decoration-none">Growth models</a> 
                                </li>                             
                            </ul>                         
                        </div>                     
                        <div className="col-md-6 col-xl-4 py-3"> 
                            <h2 className="fw-normal h5 mb-4 text-uppercase text-white">Subscribe</h2>
                            <p className="mb-4">Subscribe to our newsletter and get exclusive updates directly in your inbox.</p>
                            {this.state.subSuccess === false ?
                                <form className="mb-4" onSubmit={this.subscribe}> 
                                    <div className="bg-white border input-group p-1 rounded">
                                        <input type="email" name="subEmail" value={this.state.subEmail} onChange={this.inputChange} className="border-0 form-control pe-3 ps-3" placeholder="Enter email..." aria-label="Recipient's email" aria-describedby="button-addon2" required/>
                                        <button className="btn btn-primary pb-2 pe-4 ps-4 pt-2 rounded" type="submit" id="button-addon2" aria-label="submit">
                                            <svg viewBox="0 0 24 24" fill="currentColor" className="d-inline-block" height="16" width="16">
                                                <path d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </form>
                            : <div>Subscribed!</div>}      
                        </div>                     
                    </div>                 
                    <div className="pb-3 pt-3 small"> 
                        <hr className="border-secondary mt-0"/> 
                        <div className="align-items-center row">
                            <div className="col-md pb-2 pt-2">
                                <p className="mb-0">&copy; 2024 | All Rights Reserved - Modelr.xyz</p>
                            </div>
                            <div className="col-md-auto pb-2 pt-2">{/*<a href="#" className="link-light text-decoration-none">Privacy Policy</a> | */}<a href="/termsandconditions.html" className="link-light text-decoration-none">Terms of Use</a>
                            </div>
                        </div>                     
                    </div>                 
                </div>             
            </footer>
        </div>
      </div>
    );
  }
}

export default function LandingWithNavigation() {
    const navigate = useNavigate()
    return <Landing navigate={navigate}/>
}